<template>
    <v-card class="my-3">
        <v-card-media class="white--text" height="210px" :src="image" v-if="image">
            <v-container fill-height fluid>
                <v-layout>
                    <v-flex xs12 align-end d-flex v-if="title">
                        <span class="post-title">{{ title }}</span>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-media>

        <v-flex xs12 align-end d-flex v-else-if="title">
            <span class="post-title">{{ title }}</span>
        </v-flex>

        <v-card-text>
            {{ content }}
        </v-card-text>

        <v-card-actions v-if="url">
            <v-spacer></v-spacer>
            <v-btn flat class="blue--text" :href="url" target="_blank">Подробнее</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        components: {},
        props: {
            title: String,
            content: String,
            image: String,
            url: String
        },
        computed: {},
        methods: {}
    }
</script>

<style lang="stylus" scoped>
    .post-title {
        text-shadow rgba(34, 34, 34, 0.8) 0 0 4px
        font-size 1.4rem
        line-height 1.2
        text-align left
    }
</style>
